import store from "../../store";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { PRICEBOOK, GRID } from "../../constants";
import {
  addColumnService,
  getPriceListRowData,
  getPriceListsService,
  getProducts,
  getUnusedProductsService,
  getViewConfig,
  updatePricebookDataService,
  getAllClauses,
  addPricebookService,
  updatePricebookInfoService,
  addProductColumnService,
  getproductViewConfig,
  editProductColumnService,
  updateCrossviewOptionService,
  getcrossViewOptionservice,
} from "./pricebooksService";
import { parseRowData } from "./pricebooksMethods";

// Destructuring
const {
  NOT_APPLICABLE_WRT_CHARGETYPE_MAP: NA_CHARGETYPE_MAP,
  PB_FIELD_DB_DEFAULT_VALUES: DB_DEFAULT_VALUES,
} = PRICEBOOK;
const { PRICING_METHODS, RECURRENCE: REC_PRD_OPTIONS } = GRID;
const { twoArrayLookUp, readDataFromLocalStorage } = GlobalUtils;

const {
  BUNDLE_PRICING,
  DIY_PRICING,
  FLAT_PRICE,
  PERCENTAGE_OF_TOTAL,
  STEP_TIER_PRICING,
  TIER_PRICING,
  VOLUME_PRICING,
} = PRICING_METHODS;

export const getPriceLists = () => dispatch =>
  new Promise((resolve, reject) => {
    getPriceListsService()
      .then(response => {
        dispatch({
          type: "ADD_PRICELISTS",
          payload: response.PriceListPage.plists,
        });
        resolve(response.PriceListPage.plists);
      })
      .catch(error => {
        console.debug("pricebooksActions =>", error);
        reject(error);
      });
  });

export const getUnusedProducts = plistID => dispatch =>
  new Promise((resolve, reject) => {
    getUnusedProductsService(plistID)
      .then(response => {
        dispatch({
          type: "UNUSED_PRODUCTS",
          payload: response,
        });
        resolve("success");
      })
      .catch(error => {
        console.debug("UnusedProducts =>", error);
        reject(error);
      });
  });

export const getInitData = (pricelistId, view) => async dispatch => {
  try {
    // Fetch Column Data
    const rowData = getPriceListRowData(pricelistId, view.metaData);
    const products = getProducts();
    const clauses = getAllClauses();

    return Promise.all([view, rowData, products, clauses])
      .then(response => {
        dispatch({
          type: "REACTION_PRICEBOOK_INIT_DATA",
          payload: response,
        });
      })
      .catch(error => {
        console.debug("pricebookActions =>", error);
        throw error;
      });
  } catch (error) {
    throw error;
  }
};

export const getPricebookInitData = (pricelistId, view) => async dispatch => {
  try {
    // Fetch Column Data
    const rowData = getPriceListRowData(pricelistId, view.metaData);
    const products = getProducts();
    const clauses = getAllClauses();

    Promise.all([view, rowData, products, clauses])
      .then(response => {
        dispatch({
          type: "REACTION_PRICEBOOK_INIT_DATA",
          payload: response,
        });
      })
      .catch(error => {
        console.debug("pricebookActions =>", error);
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const updatePricebookData = (obj, flag) => dispatch =>
  new Promise((resolve, reject) => {
    updatePricebookDataService(obj)
      .then(response => {
        const data = parseRowData(response, flag);
        dispatch({
          type: "UPDATE_ROW_DATA",
          payload: data,
        });
        resolve("success");
      })
      .catch(error => {
        console.debug("productActions =>", error);
        reject(error);
      });
  });

export const addColumn = (payload, pricelistId) => async dispatch => {
  try {
    // Add New Column to Grid
    const addNewColumn = await addColumnService(payload);
    const view = await getViewConfig(pricelistId);

    return Promise.all([addNewColumn, view])
      .then(response => {
        dispatch({
          type: "REACTION_PRICEBOOK_ADD_COLUMN",
          payload: response,
        });
        return response[0];
      })
      .catch(error => {
        console.debug("pricebookActions =>", error);
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
export const editPricebookColumn =
  (payload, columnId, PricelistItemsView, pricelistId) => async dispatch => {
    try {
      // const getAppView = readDataFromLocalStorage("appView");
      // const { PricelistItemsView } =
      //   getAppView && getAppView.views ? getAppView.views : {};
      // Add New Column to Grid
      const addNewColumn = await editProductColumnService(
        payload,
        columnId,
        PricelistItemsView,
      );
      const view = await getViewConfig(pricelistId);

      Promise.all([addNewColumn, view])
        .then(response => {
          dispatch({
            type: "REACTION_PRICEBOOK_ADD_COLUMN",
            payload: response,
          });
        })
        .catch(error => {
          console.debug("pricebookActions =>", error);
          throw error;
        });
      return null;
    } catch (error) {
      throw error;
    }
  };

export const addProductColumn = (payload, pageView) => async dispatch => {
  try {
    const getAppView = readDataFromLocalStorage("appView");
    const { ProductsView } =
      getAppView && getAppView.views ? getAppView.views : {};
    const addNewColumn = await addProductColumnService(payload, pageView);
    const view = await getproductViewConfig(ProductsView);

    return Promise.all([addNewColumn, view])
      .then(response => {
        dispatch({
          type: "REACTION_PRODUCT_ADD_COLUMN",
          payload: response,
        });
        return response[0];
      })
      .catch(error => {
        console.debug("pricebookActions =>", error);
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
export const editProductColumn =
  (payload, columnId, ProductsViews) => async dispatch => {
    try {
      const getAppView = readDataFromLocalStorage("appView");
      const { ProductsView } =
        getAppView && getAppView.views ? getAppView.views : {};
      const addNewColumn = await editProductColumnService(
        payload,
        columnId,
        ProductsViews,
      );
      const view = await getproductViewConfig(ProductsView);

      Promise.all([addNewColumn, view])
        .then(response => {
          dispatch({
            type: "REACTION_PRODUCT_ADD_COLUMN",
            payload: response,
          });
        })
        .catch(error => {
          console.debug("pricebookActions =>", error);
          throw error;
        });
      return null;
    } catch (error) {
      throw error;
    }
  };

export const updateCrossviewOption =
  (payload, ProductsViews) => async dispatch => {
    try {
      const getAppView = readDataFromLocalStorage("appView");
      const { ProductsView } =
        getAppView && getAppView.views ? getAppView.views : {};
      const addNewColumn = await updateCrossviewOptionService(
        payload,
        ProductsViews,
      );
      const view = await getproductViewConfig(ProductsView);

      Promise.all([addNewColumn, view])
        .then(response => {
          dispatch({
            type: "COLUMN",
            payload: response,
          });
        })
        .catch(error => {
          console.debug("pricebookActions =>", error);
          throw error;
        });
      return null;
    } catch (error) {
      throw error;
    }
  };

export const getcrossViewOptionAction = (columnId, view) => dispatch =>
  new Promise((resolve, reject) => {
    getcrossViewOptionservice(columnId, view)
      .then(response => {
        dispatch({
          type: "PRICELISTS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("productActions =>", error);
        reject(error);
      });
  });
export const updateFormDummyFields = data => dispatch => {
  const reduxState = store.getState();
  const {
    metaData: { fieldMapIndex } = {},
    products,
    unusedProducts,
  } = reduxState.PricebookStore;
  if (Object.prototype.hasOwnProperty.call(data, fieldMapIndex.product)) {
    if (data[fieldMapIndex.product]) {
      const selectedProduct = twoArrayLookUp(
        products,
        unusedProducts,
        data[fieldMapIndex.product],
      );
      const tempObj = {
        productSKU: selectedProduct.sku,
        productCode: selectedProduct.code,
        productConfig: selectedProduct.config_type,
      };
      dispatch({
        type: "FORM_DUMMY_FIELDS",
        payload: tempObj,
      });
    }
  }
};

// Rewrite
// this should be moved to methods file + plus add a comment before every if statement for why

const checkFields = data => {
  const reduxState = store.getState();
  const {
    metaData: { fieldMapIndex },
    pricingMethodData,
  } = reduxState.PricebookStore;

  /**
   * Changes in formRowData due to changes in charge_type value below
   */
  Object.entries(NA_CHARGETYPE_MAP).forEach(item => {
    const [fieldName, chargeTypeValues] = item;
    if (chargeTypeValues.includes(data[fieldMapIndex.charge_type])) {
      data[fieldMapIndex[fieldName]] = DB_DEFAULT_VALUES[fieldName];
    }
  });

  /**
   * Change Min Selling Term Value based on charge type selection
   */
  if (
    data[fieldMapIndex.charge_type] &&
    ["One Time", "Recurring", "Recurring Usage"].includes(
      data[fieldMapIndex.charge_type],
    ) &&
    data[fieldMapIndex.selling_term] === 0
  ) {
    data[fieldMapIndex.selling_term] = 1;
  }

  /**
   * Reset Selling Term UOM (Recurring Period) if current selected value of Charge Frequency is greater than val of SellingTermUOM
   */
  if (
    data[fieldMapIndex.charge_frequency] &&
    data[fieldMapIndex.recurring_period] &&
    REC_PRD_OPTIONS[data[fieldMapIndex.charge_frequency]] >
      REC_PRD_OPTIONS[data[fieldMapIndex.recurring_period]]
  ) {
    data[fieldMapIndex.recurring_period] = "";
  }

  /**
   * Reset Selling Term UOM (Recurring Period) if current selected value of Charge Frequency is greater than val of SellingTermUOM
   */

  const { view: pricingView } = pricingMethodData;

  switch (pricingView) {
    case STEP_TIER_PRICING:
    case TIER_PRICING:
    case VOLUME_PRICING:
      data[fieldMapIndex.qty_editable] = true;
      break;
    case FLAT_PRICE:
    case DIY_PRICING:
      if (
        data[fieldMapIndex.quantity_uom] === "" ||
        !Object.prototype.hasOwnProperty.call(data, fieldMapIndex.quantity_uom)
      ) {
        data[fieldMapIndex.qty_editable] = false;
      }
      break;
    case BUNDLE_PRICING:
      if (
        data[fieldMapIndex.price] &&
        data[fieldMapIndex.price].isAdhoc === true
      ) {
        data[fieldMapIndex.qty_editable] = true;
      } else {
        data[fieldMapIndex.qty_editable] = false;
      }
      break;
    case PERCENTAGE_OF_TOTAL:
      data[fieldMapIndex.qty_editable] = false;
      data[fieldMapIndex.sku_quantity_editable] = false;
      data[fieldMapIndex.sellingterm_editable] = false;
      break;

    default:
      data[fieldMapIndex.qty_editable] = true;
      break;
  }

  if (data[fieldMapIndex.recurring_period] === "") {
    data[fieldMapIndex.sellingterm_editable] = false;
  }

  return data;
};

export const updateFormRowData = data => dispatch => {
  dispatch({
    type: "FORM_ROW_DATA",
    payload: checkFields(data),
  });
  store.dispatch(updateFormDummyFields(data));
};

// eslint-disable-next-line no-unused-vars
export const updateFormRowDataField = (fld, value) => dispatch => {
  if (fld) {
    const reduxState = store.getState();
    const { formRowData } = reduxState.PricebookStore;
    const data = { ...formRowData };
    data[fld] = value;
    store.dispatch(updateFormRowData(data));
  }
};

export const updatePricingMethodData = (key, value) => dispatch => {
  const reduxState = store.getState();
  const { pricingMethodData } = reduxState.PricebookStore;
  const obj = { ...pricingMethodData };
  if (typeof key === "object") {
    // eslint-disable-next-line no-restricted-syntax
    for (const label in key) {
      if (Object.prototype.hasOwnProperty.call(key, label)) {
        obj[label] =
          typeof key[label] === "string" || "boolean" // eslint-disable-line no-constant-condition
            ? key[label]
            : { ...obj[key], ...key[label] };
      }
    }
  } else {
    obj[key] = typeof value === "string" ? value : { ...obj[key], ...value };
  }
  dispatch({
    type: "UPDATE_PRICING_METHOD_DATA",
    payload: obj,
  });
};

export const nukePriceListForm = () => dispatch => {
  dispatch({
    type: "NUKE_PRICELIST_FORM",
  });
};

export const nukeGridData = () => dispatch => {
  dispatch({
    type: "UPDATE_ROW_DATA",
    payload: [],
  });
};

export const updatePbItemEditorRequiredFields =
  (fieldName, keepFieldName) => dispatch => {
    const reduxState = store.getState();
    const { pbItemEditorRequiredFields } = reduxState.PricebookStore;
    let tempFields = [...pbItemEditorRequiredFields];

    if (keepFieldName && !tempFields.includes(fieldName)) {
      tempFields = [...tempFields, fieldName];
    }
    if (!keepFieldName && tempFields.includes(fieldName)) {
      tempFields = tempFields.filter(item => item !== fieldName);
    }

    dispatch({
      type: "PB_ITEM_EDITOR_REQUIRED_FIELDS",
      payload: tempFields,
    });
  };

export const addPriceList = pb => dispatch =>
  new Promise((resolve, reject) => {
    addPricebookService(pb)
      .then(response => {
        const reduxState = store.getState();
        const { pricelists } = reduxState.PricebookStore;
        dispatch({
          type: "ADD_PRICELISTS",
          payload: [...pricelists, response.PriceList],
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("pricebooksActions =>", error);
        reject(error);
      });
  });

export const updatePricebookInfo = pb => dispatch =>
  new Promise((resolve, reject) => {
    updatePricebookInfoService(pb)
      .then(response => {
        const reduxState = store.getState();
        const { pricelists } = reduxState.PricebookStore;
        const updatedPbIndex = pricelists.findIndex(
          pbook => pbook.id === pb.id,
        );
        pricelists[updatedPbIndex] = response.PriceList;

        dispatch({
          type: "ADD_PRICELISTS",
          payload: [...pricelists],
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("pricebooksActions =>", error);
        reject(error);
      });
  });
